import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Section } from 'components/misc'
import { Title } from './styled'
import { Slider } from './slider'

export const Leaders = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section ref={ref}>
    <Title data-menu-title="красные лидеры">
      <TextContainer>Красные лидеры</TextContainer>
    </Title>
    <TextContainer>
      <p>
        В Республике Саха в дискуссии об автономии выделяют трех политических
        деятелей начала XX века: Максима Аммосова, Степана Аржакова и Платона
        Ойунского. Все они – большевики и сыграли важную роль в становлении
        автономии для Якутской АССР.
      </p>
      <p>
        После установления советской власти в 1918 году в регионе началась серия
        вооруженных восстаний. Они продолжались вплоть до 1930 года. Новые
        власти их жестоко подавили.
      </p>
      <p>
        Несмотря на их роль в становлении советской власти, в 1930-х годах тройку и их единомышленников объявили "врагами народа", арестовали по подозрению в контрреволюционной деятельности и вскоре расстреляли. Всех их позже реабилитировали – посмертно. Сегодня в республике их именами называют государственные учреждения, улицы и ставят памятники.
      </p>
    </TextContainer>

    <Slider />

  </Section>
))
